import * as React from 'react'
import { cn } from '@/lib/cn'

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Add cyber accent border/glow */
  accent?: boolean
  /** Enable hover animations */
  hover?: boolean
  /** Children elements */
  children: React.ReactNode
}

/**
 * Glassmorphic card component with cyber/teal theming
 *
 * @example
 * <GlassCard>Basic glass card</GlassCard>
 * <GlassCard accent>Card with cyber accent</GlassCard>
 * <GlassCard hover>Card with hover effect</GlassCard>
 */
const GlassCard = React.forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, accent = false, hover = false, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'glass-card rounded-xl p-6 md:p-8',
          accent && 'cyber-accent',
          hover && 'hover:glow-cyber-sm transition-all duration-300 hover:-translate-y-1',
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)
GlassCard.displayName = 'GlassCard'

export { GlassCard }
